import React from 'react';

const LinearIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <linearGradient id="linearIconGradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#5E6AD2" />
        <stop offset="100%" stopColor="#3F4AB5" />
      </linearGradient>
    </defs>
    <rect width="100" height="100" rx="22" fill="url(#linearIconGradient)" />
    <path
      d="M21.6 51.7c0-.6.7-.9 1.1-.5l26.1 26.1c.4.4.1 1.1-.5 1.1-13.5-.7-24.3-11.4-26.7-26.7zM21.5 41.5c0-.2 0-.5.1-.7L40.2 59.5c.2.2.5.3.7.3 6.6-.1 11.9-5.4 12-12 0-.3-.1-.5-.3-.7L34.1 28.4c-.2-.2-.5-.2-.7-.1-7 4.1-11.9 11.7-11.9 13.2zM43.5 23.6c-.4-.4-.1-1 .4-1.1 1.9-.3 3.8-.5 5.7-.5 15.6 0 28.2 12.6 28.2 28.2 0 1.9-.2 3.8-.5 5.7-.1.5-.7.7-1.1.4L43.5 23.6z"
      fill="#FFFFFF"
    />
  </svg>
);

export default LinearIcon;
